module.exports = __webpack_public_path__ + "static/media/image-card-3.7a9e7563.png";